export enum ImageStoreStatus {
  Invalid = 0,
  Pending = 3,
  Uploaded = 4,
  Formatted = 5,
  Finished = 6,
  Error = 9,
  Resumable = 10,
}

export enum ImageOp {
  Invalid = 0,
  ResumeImage = 1,
  SwitchToIndependentBilling = 2,
}

export enum ImageProvider {
  UserUploaded = 0,
  RegistryURL = 1,
}

export enum ImageFormat {
  Container = 0, // Overlay2
  VM = 1, // ZfsVolume (RAW)
}

export const IMAGE_NAME_MAX_LENGTH = 200
export const REGISTRY_URL_MAX_LENGTH = 200
export const IMAGE_DESCRIPTION_MAX_BYTES = 1024

export const REGISTRY_URL_PATTERN =
  /^(([a-z0-9_.-]+)(:\d{1,5}){0,1}){0,1}((\/[a-z0-9_.-]+)*\/)*[a-z0-9_.-]+(:[a-zA-Z0-9_.-]+){0,1}$/

export function isValidRegistryUrl(url: string): boolean {
  const trimmed = url.trim()
  if (!trimmed) return false
  return REGISTRY_URL_PATTERN.test(trimmed)
}

export function isImportFormReady(values: {
  imageName?: string
  registryLink?: string
  registryType?: 'public' | 'private'
  repositoryUsername?: string
  repositoryPassword?: string
}): boolean {
  const imageName = values.imageName?.trim() ?? ''
  const registryLink = values.registryLink?.trim() ?? ''

  if (!imageName || imageName.length > IMAGE_NAME_MAX_LENGTH) return false
  if (!registryLink || registryLink.length > REGISTRY_URL_MAX_LENGTH) return false
  if (!isValidRegistryUrl(registryLink)) return false

  if (values.registryType === 'private') {
    if (!values.repositoryUsername?.trim() || !values.repositoryPassword?.trim()) return false
  }

  return true
}

export const getUtf8ByteLength = (value: string): number => new TextEncoder().encode(value).length

export const AVAILABLE_CUSTOM_IMAGE_STATUSES = [
  ImageStoreStatus.Invalid,
  ImageStoreStatus.Formatted,
] as const

export const PENDING_CUSTOM_IMAGE_STATUSES = [ImageStoreStatus.Pending] as const

export const IMAGE_STORE_STATUS_LABELS = {
  [ImageStoreStatus.Invalid]: 'Invalid',
  [ImageStoreStatus.Pending]: 'Pending',
  [ImageStoreStatus.Uploaded]: 'Uploaded',
  [ImageStoreStatus.Formatted]: 'Formatted',
  [ImageStoreStatus.Finished]: 'Finished',
  [ImageStoreStatus.Error]: 'Error',
  [ImageStoreStatus.Resumable]: 'Restorable',
} as const

// Machine attribute tags for filtering official images
export enum MachineAttrTag {
  Container = 16384,
  VirtualMachine = 2048,
}

export const MACHINE_ATTR_TAG_OPTIONS = [
  { value: MachineAttrTag.Container, labelKey: 'customImage.filter.container' },
  { value: MachineAttrTag.VirtualMachine, labelKey: 'customImage.filter.virtualMachine' },
] as const
